// src/pages/About.js
import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Герой */}
      <section className="about-hero">
        <div className="hero-overlay">
          <h1>О нас</h1>
          <p>Мы — современная логистическая компания, предоставляющая комплексные решения для бизнеса.
          Берем на себя всю ответственность за ваш груз: от момента отправки до конечного получателя. Мы делаем процесс перевозки простым, выгодным и надежным.</p>
        </div>
      </section>

      {/* О компании */}
          <section className="about-company">
      <div className="container">
        <h2>Почему выбирают нас:</h2>
        <ul className="benefits-list">
          <li className="benefit-item">
            <h3>Ответственность на каждом этапе</h3>
            <p>Контролируем весь путь груза — вы можете быть уверены в результате.</p>
          </li>
          <li className="benefit-item">
            <h3>Выгодные тарифы</h3>
            <p>Предлагаем одни из лучших ставок на рынке, помогая экономить без потерь в качестве сервиса.</p>
          </li>
          <li className="benefit-item">
            <h3>Оперативная доставка</h3>
            <p>Четкая логистика и слаженная работа команды позволяют доставлять грузы в кратчайшие сроки.</p>
          </li>
        </ul>
      </div>
    </section>




      {/* Миссия и ценности */}
      <section className="about-mission">
        <div className="container">
          <h2>Наша миссия и ценности</h2>
          <div className="mission-values">
            <div className="value-item">
              <h3>Миссия</h3>
              <p>
                Обеспечивать надежное и эффективное транспортное решение, способствуя развитию партнерских отношений и росту бизнеса наших клиентов.
              </p>
            </div>
            <div className="value-item">
              <h3>Ценности</h3>
              <ul>
                <li>Надежность</li>
                <li>Качество</li>
                <li>Инновации</li>
                <li>Ответственность</li>
                <li>Открытость</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* История компании */}
      <section className="about-history">
        <div className="container">
          <h2>Наша история</h2>
          <p>
            С момента основания мы постоянно растем, внедряя передовые технологии и оптимизируя процессы. Наш опыт и профессионализм позволяют успешно реализовывать проекты любой сложности.
          </p>
        </div>
      </section>

      {/* Команда */}
      <section className="about-team">
        <div className="container">
          <h2>Наша команда</h2>
          <p>
          Успех каждой доставки — заслуга наших людей.
          В нашей команде работают опытные логисты, диспетчеры и менеджеры, которые знают рынок и умеют быстро находить решения в любых ситуациях. Мы постоянно обучаемся, внедряем новые технологии и следим за качеством обслуживания.
          </p>
          {/* Здесь можно добавить галерею или слайдер с фотографиями сотрудников */}
        </div>
      </section>
    </div>
  );
};

export default About;
